import React, { useEffect, useState } from "react";
import "./PageView.scss";
import { createWithQueryHOC } from "@/components/WithQuery";
import { useMainPanel, useListenMainPanelEvent } from "@/hooks/service";
import logger from "@/utils/logger";
import { usePullToRefresh } from "@/hooks";

const MapToolPage = React.lazy(() => import("./MapToolPage"));

interface IPageViewProps {
  data?: any;
}
const PageView: React.FC<IPageViewProps> = props => {
  const [data, setData] = useState(props.data);

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  useListenMainPanelEvent(data => {
    setData(data);
  });

  useEffect(() => {
    logger.log("getLuckyBagPanel data", data);
  }, [data]);

  usePullToRefresh(() => {
    console.log("🔥下拉刷新触发");
  });

  return <MapToolPage></MapToolPage>;
};

export default createWithQueryHOC({
  comName: "PageView",
  Com: PageView,
  useQueryHook: useMainPanel,
});
